<div class="step-container">
  <h2 class="step-titulo">Endereço da sua loja online</h2>
  <p class="step-subtitulo">Escolha o endereço que seus clientes vão acessar.</p>

  <div class="subdominio-wrapper">
    <div class="subdominio-input-group" [class.campo-shake]="shakeSubdominio">
      <input type="text" class="subdominio-input"
             [(ngModel)]="subdominio"
             (ngModelChange)="onDigitar()"
             placeholder="sualojaaqui"
             maxlength="30"
             (keyup.enter)="avancar()">
      <span class="subdominio-sufixo">.meucardapio.ai</span>
    </div>

    <div class="subdominio-status" *ngIf="subdominio.length >= 3">
      <span *ngIf="verificando" class="status-verificando">
        <i class="fe-loader spin"></i> Verificando...
      </span>
      <span *ngIf="!verificando && disponivel === true" class="status-disponivel">
        <i class="fe-check-circle"></i> Disponível!
      </span>
      <span *ngIf="!verificando && disponivel === false" class="status-indisponivel">
        <i class="fe-x-circle"></i> Já está em uso. Tente outro nome.
      </span>
    </div>

    <div class="subdominio-preview" *ngIf="subdominio.length >= 3 && disponivel">
      <span class="preview-label">Seus clientes acessarão:</span>
      <span class="preview-url">{{ subdominio }}.meucardapio.ai</span>
    </div>
  </div>

  <div class="step-actions">
    <button class="btn-anterior" (click)="voltar()">
      <i class="fe-arrow-left mr-1"></i> Anterior
    </button>
    <div class="d-flex flex-column align-items-end">
      <p class="text-danger mb-1" *ngIf="erroValidacao">
        <i class="fe-alert-circle mr-1"></i> {{ erroValidacao }}
      </p>
      <button class="btn-proximo" (click)="avancar()">
        Próximo <i class="fe-arrow-right ml-1"></i>
      </button>
    </div>
  </div>
</div>
